<app-gallery-banner-homepage></app-gallery-banner-homepage>

<section class="container">
  <div class="section-product-border"></div>
  <div class="row section-product-in-evidence">
    <div class="col-60">
      <app-homepage-product-in-evidence></app-homepage-product-in-evidence>
    </div>
  </div>
</section>
<section class="w-100 section-catalog">
  <app-homepage-catalog></app-homepage-catalog>
</section>
<section class="w-100">
  <app-gallery-homepage></app-gallery-homepage>
</section>
<section class="w-100 section-sectors">
  <app-homepage-sectors></app-homepage-sectors>
</section>
<section class="w-100 section-statistics">
  <app-homepage-statistics></app-homepage-statistics>
</section>

<section class="section-news padding-go-up-button">
  <app-homepage-news></app-homepage-news>
</section>

<app-link-popup-dialog></app-link-popup-dialog>
